import React, { useEffect, useState, useCallback } from "react";
import {
  Box, Flex, Text,
  useDisclosure,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Image,
  Button,
  HStack,
} from "@chakra-ui/react";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

import apiClient from "Configuration/apiClient";
import API_CONFIG from "../../Configuration/apiConfig";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#C72127",
    borderColor: "white",
    fontWeight: "bold",
    minHeight: "40px",
    borderRadius: "12px",
    boxShadow: state.isFocused ? '0 0 0 3px rgba(199, 33, 39, 0.3)' : 'none',
    cursor: 'pointer',
    "&:hover": {
      borderColor: "white",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "white",
    fontWeight: "bold",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#fff",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#2D3748",
    fontWeight: "600",
  }),
  multiValueRemove: (base) => ({
    ...base,
    "&:hover": {
      backgroundColor: "#e70b0b",
      color: "white",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "white",
    fontWeight: "bold",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#2C7A7B"
      : state.isFocused
        ? "#E6FFFA"
        : "white",
    color: state.isSelected ? "white" : "#2D3748",
  }),
}

export default function VisiCoolerImageReport() {
  const [filterStores, setFilterStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [storeName, setStoreName] = useState([]);
  const [error, setError] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [filteredCount, setFilteredCount] = useState(0);
  const [downloadLoading, setDownloadLoading] = useState(false);;
  const [asm, setAsm] = useState([]);
  const [selectedAsm, setSelectedAsm] = useState([]);
  const [Rsm, setRsm] = useState([]);
  const [selectedRsm, setSelectedRsm] = useState([]);
  const [asmLoading, setAsmLoading] = useState(false);
  const [rsmLoading, setRsmLoading] = useState(false);

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const date = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${date}`;
  };

  const getFirstDayOfMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}-01`;
  };

  const [fromDate, setFromDate] = useState(getFirstDayOfMonth);
  const [toDate, setToDate] = useState(getCurrentDate());

  const handleFromDateChange = (value) => {
    setFromDate(value);
    if (value > toDate) {
      setToDate(value);
    }
  };

  const handleToDateChange = (value) => {
    if (value < fromDate) return;
    setToDate(value);
  };



  const generatePresignedUrl = async (s3Path, month, year) => {
    const presignedEndpoint = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${encodeURIComponent(
      s3Path
    )}&bucketName=imageinsightimagesbeverages&operation=download&month=${month}&year=${year}`;

    try {
      const response = await fetch(presignedEndpoint);
      if (!response.ok) throw new Error("Failed to fetch presigned URL");
      const presignedUrl = await response.text();
      return presignedUrl.trim();
    } catch (err) {
      console.error("Failed to generate presigned URL:", err);
      return null;
    }
  };

  const handleViewDetails = async (store) => {
    setSelectedStore(store);
    setImageUrl(null);
    onOpen();

    if (store.imagePath) {
      setImageLoading(true);
      try {
        const [year, month] = toDate.split("-").map(v => parseInt(v, 10));

        const presignedUrl = await generatePresignedUrl(
          store.imagePath,
          month,
          year
        );

        if (presignedUrl) {
          setImageUrl(presignedUrl);
        }
      } catch (error) {
        console.error('Failed to load image:', error);
      } finally {
        setImageLoading(false);
      }
    }
  };

  const fetchDropdownData = async (searchType, setoptions, setLoading) => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.VISICOOLER.ASMDP}`,
        { params: { search: searchType } }
      );
      const data = response.data

      const formattedOptions = data.map((item) => ({
        value: item,
        label: item,
      }));
      setoptions(formattedOptions)
    } catch (err) {
      console.error(`Failde to fetch ${searchType}:`, err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDropdownData("ASM", setAsm, setAsmLoading);
  }, [])
  useEffect(() => {
    fetchDropdownData("RSM", setRsm, setRsmLoading);
  }, []);


  useEffect(() => {
    if (!fromDate || !toDate) return;
    setLoading(true);
    const fetchStoreNames = async () => {
      setStoreName([]);

      const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(v => parseInt(v, 10));
      const [toYear, toMonthNum, toDay] = toDate.split("-").map(v => parseInt(v, 10));
      const requestBody = {
        timePeriod: {
          from: {
            date: fromDay,
            month: fromMonthNum,
            year: fromYear,
          },
          to: {
            date: toDay,
            month: toMonthNum,
            year: toYear
          }
        },
        filters: {
          asmName: selectedAsm.map(asm => asm.value),
          rsmName: selectedRsm.map(rsm => rsm.value)
        }
      }

      try {
        const res = await apiClient.post(
          `${API_CONFIG.ENDPOINTS.VISICOOLER.STORE_WISE_IMAGES}`,
          requestBody
        );

        if (!res.data || !Array.isArray(res.data)) {
          setStoreName([]);
          setFilterStores([]);
          return;
        }

        const data = res.data.map((item) => ({
          storeName: item.storeResponse?.storeName || "",
          Ps: item.storeAdditionalDetails?.psName || "",
          distributor: item.storeAdditionalDetails?.distributor || "",
          so: item.storeAdditionalDetails?.salesOfficer || "",
          customerID: item.storeAdditionalDetails?.customer || "",
          imagePath: item.coolerImagePath || null,
        })).sort((a, b) => {
          const nameA = a.storeName.toLowerCase();
          const nameB = b.storeName.toLowerCase();

          const startsWithLetterA = /^[a-z]/i.test(nameA);
          const startsWithLetterB = /^[a-z]/i.test(nameB);

          if (startsWithLetterA && !startsWithLetterB) return -1;
          if (!startsWithLetterA && startsWithLetterB) return 1;

          return nameA.localeCompare(nameB);
        })

        setStoreName(data);
        setFilterStores(data);

      } catch (err) {
        console.error("Failed to fetch  store names:", err);
        setError("Failed to fetch store names. Please try again.");
        setStoreName([]);
      } finally {
        setLoading(false);
      }
    };
    fetchStoreNames();
  }, [fromDate, toDate, selectedAsm, selectedRsm]);

  const onFilterChanged = useCallback((params) => {
    if (params && params.api) {
      const displayedRowCount = params.api.getDisplayedRowCount();
      setFilteredCount(displayedRowCount);
    }
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setFilteredCount(params.api.getDisplayedRowCount());
  };

  const totalPages = Math.ceil(filteredCount / pageSize);


  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      gridApi?.paginationGoToPreviousPage();
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      gridApi?.paginationGoToNextPage();
    }
  };

  const handleDownloadImages = async () => {
    try {
      setDownloadLoading(true);

      const filterData = [];
      if (gridApi) {
        gridApi.forEachNodeAfterFilter((node) => filterData.push(node.data));
      }
      const dataToDownload = filterData.length > 0 ? filterData : filterStores;
      const storesWithImages = dataToDownload.filter(store => store.imagePath);

      if (storesWithImages.length === 0) {
        alert("No images available to download!");
        setDownloadLoading(false);
        return;
      }

      const zip = new JSZip();
      const [year, month] = toDate.split("-").map(v => parseInt(v, 10));

      for (let i = 0; i < storesWithImages.length; i++) {
        const store = storesWithImages[i];
        try {
          const customerID = store.customerID ? store.customerID : "0";
          const fileName = `${customerID}.jpg`;

          const presignedUrl = await generatePresignedUrl(store.imagePath, month, year);
          if (!presignedUrl) continue;

          const response = await fetch(presignedUrl);
          if (!response.ok) continue;

          const blob = await response.blob();
          zip.file(fileName, blob);

        } catch (error) {
          console.error(`Unexpected error for store index ${i}:`, error);
        }
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      const zipFileName = `Visicooler_Images_${fromDate}_to_${toDate}.zip`;
      saveAs(zipBlob, zipFileName);

    } catch (error) {
      console.error("Download process failed:", error);
      alert("Failed to download images. Please try again.");
    } finally {
      setDownloadLoading(false);
    }
  };



  // AG Grid Column Definitions
  const columnDefs = [
    {
      headerName: "Sales Officer",
      field: "so",
      minwidth: 130,
      flex: 1,
    },
    {
      headerName: "PS Name",
      field: "Ps",
      minwidth: 130,
      flex: 1,
    },
    {
      headerName: "Distributor Name",
      field: "distributor",
      minWidth: 130,
      flex: 1,
    },

    {
      headerName: "Store Name",
      field: "storeName",
      minWidth: 130,
      flex: 1,
    },
    {
      headerName: "Customer ID",
      field: "customerID",
      minWidth: 90,
      flex: 0.8,
    },

    {
      headerName: "Images",
      field: "imagePath",
      cellRenderer: (params) => {
        return params.value ? (
          <Flex align="center" h="100%">
            <Button
              size="sm"
              colorScheme="red"
              variant="outline"
              onClick={() => handleViewDetails(params.data)}
              leftIcon={<Box as="span">👁</Box>}
              fontSize={{ base: "xs", md: "md" }}
            >
              View
            </Button>
          </Flex>
        ) : (
          <Text color="gray.500" fontSize={{ base: "xs", sm: "sm", md: "md" }}>
            N/A
          </Text>
        );
      },
      minWidth: 120,
      flex: 0.8,
      cellStyle: { display: 'flex', alignItems: 'center' }
    },
  ];

  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    suppressMovable: true,
    filterParams: {
      maxNumConditions: 1,
      buttons: ['reset'],
    },
    suppressCellFocus: false,
    wrapText: true,
    autoHeight: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'normal',
      lineHeight: '1.5'
    }


  };

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      pt={{ base: "7vh", sm: "8vh", md: "9vh", lg: "10vh" }}
      px={{ base: 3, sm: 4, md: 6, lg: 8 }}
      pb={{ base: 4, sm: 5, md: 6 }}
    >
      <Box mb={{ base: 4, sm: 5, md: 6 }}>
        <Flex
          direction={{ base: "column", sm: "row" }}
          justify="space-between"
          align={{ base: "flex-start", sm: "center" }}
          mb={{ base: 3, sm: 4, md: 4 }}
          gap={{ base: 3, sm: 0 }}
        >
          {/* Heading */}
          <Heading
            as="h1"
            fontSize={{ base: "20px", sm: "25px", md: "30px", lg: "35px" }}
            fontWeight="bold"
            color="gray.800"
            mb={{ base: 3, sm: 4, md: 4 }}
          >
            Store-wise Visicooler Images
          </Heading>
          {/* Date Filters - Right Side */}
          <Flex
            gap={{ base: 2, sm: 3, md: 3 }}
            direction={{ base: "column", sm: "row" }}
            w={{ base: "100%", sm: "auto" }}
            align={{ base: "stretch", sm: "flex-end" }}
            order={{ base: 1, sm: 2 }}
          >
            {/* FROM Date */}
            <Box w={{ base: "100%", sm: "auto" }}>
              <Text
                fontSize={{ base: "xs", sm: "sm", md: "md" }}
                color="gray.800"
                fontWeight="bold"
                mb={1}
                mx={2}
              >
                From Date
              </Text>
              <Box
                as="input"
                type="date"
                value={fromDate}
                max={toDate}
                onChange={(e) => handleFromDateChange(e.target.value)}
                w={{ base: "100%", md: "180px" }}
                p={{ base: "5px 8px", sm: "7px 11px", md: "8px 12px" }}
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.300"
                bg="white"
                fontSize={{ base: "13px", sm: "15px", md: "16px" }}
                cursor="pointer"
                transition="all 0.2s"
                _hover={{ borderColor: "gray.400" }}
                _focus={{
                  outline: "none",
                  borderColor: "red.500",
                  boxShadow: "0 0 0 3px rgba(244, 0, 9, 0.3)",
                }}
              />
            </Box>

            {/* TO Date */}
            <Box w={{ base: "100%", sm: "auto" }}>
              <Text
                fontSize={{ base: "xs", sm: "sm", md: "md" }}
                fontWeight="bold"
                mb={1}
                mx={2}
                color="gray.800"
              >
                To Date
              </Text>
              <Box
                as="input"
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(e) => handleToDateChange(e.target.value)}
                w={{ base: "100%", md: "180px" }}
                p={{ base: "5px 8px", sm: "7px 11px", md: "8px 12px" }}
                borderRadius="8px"
                border="1px solid"
                borderColor="gray.300"
                bg="white"
                fontSize={{ base: "13px", sm: "15px", md: "16px" }}
                cursor="pointer"
                transition="all 0.2s"
                _hover={{ borderColor: "gray.400" }}
                _focus={{
                  outline: "none",
                  borderColor: "red.500",
                  boxShadow: "0 0 0 3px rgba(244, 0, 9, 0.3)",
                }}
              />
            </Box>
          </Flex>
        </Flex>
        <HStack spacing={{ base: 3, md: 5 }}
          align="flex-start"
          flexDir={{ base: "column", lg: "row" }}>

            <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, md: 6, lg: 0 }}
            borderRadius="18px"
            boxShadow="0 2px 4px rgba(199, 33, 39, 0.3)"
          >
            <Select
              isMulti
              placeholder="RSM Name"
              options={Rsm}
              isLoading={rsmLoading}
              onChange={setSelectedRsm}
              isDisabled={rsmLoading}
              loadingMessage={() => "Loading Rsm ..."}
              noOptionsMessage={() => "No Rsm found"}
              styles={customSelectStyles}
            />

          </Box>

          <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, md: 6, lg: 0 }}
            borderRadius="18px"
            boxShadow="0 4px 6px rgba(199, 33, 39, 0.3)"
          >
            <Select
              isMulti
              placeholder="ASM Name"
              options={asm}
              value={selectedAsm}
              onChange={setSelectedAsm}
              styles={customSelectStyles}
              isLoading={asmLoading}
              isDisabled={asmLoading}
              loadingMessage={() => "Loading ASM..."}
              noOptionsMessage={() => "No ASM found"}

            />
          </Box>
          
          <Box w={{ base: "100%", sm: "auto" }} order={{ base: 2, sm: 1 }}>
            <Flex gap={3} align="center" direction={{ base: "column", sm: "row" }}>
              <Flex
                align="center"
                gap={1.5}
                bg={filteredCount < filterStores.length ? "red.500" : "red.500"}
                px={{ base: 3, md: 4 }}
                py={{ base: 1, md: 1.5 }}
                borderRadius="full"
                boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
              >
                <Text
                  fontSize={{ base: "xs", sm: "sm", md: "md" }}
                  fontWeight="bold"
                  color="white"
                >
                  {filteredCount < filterStores.length ? "Filtered:" : "Total:"}
                </Text>
                <Text
                  color="white"
                  fontSize={{ base: "sm", sm: "md", md: "lg" }}
                  fontWeight="bold"
                >
                  {filteredCount} Stores
                </Text>
              </Flex>
              <Button
                colorScheme="red"
                size={{ base: "sm", md: "md" }}
                onClick={handleDownloadImages}
                isLoading={downloadLoading}
                loadingText="Downloading..."
                spinner={<Spinner size="sm" color="white" />}
                rightIcon={
                  !downloadLoading ? (
                    <Box as="span" fontSize={{ base: "14px", md: "18px" }}
                    >
                      ⬇
                    </Box>
                  ) : null
                }
                w={{ base: "100%", sm: "auto" }}
                h={{ base: "32px", sm: "38px", md: "42px" }}
                px={{ base: 6, md: 9 }}
                fontSize={{ base: "xs", sm: "sm", md: "md" }}
                fontWeight="bold"
                boxShadow="0 2px 4px rgba(199, 33, 39, 0.3)"
                _hover={{
                  transform: downloadLoading ? "none" : "translateY(-2px)",
                  boxShadow: downloadLoading ? "0 2px 4px rgba(199, 33, 39, 0.3)" : "0 4px 8px rgba(199, 33, 39, 0.4)",
                }}
                transition="all 0.2s"
                isDisabled={downloadLoading}
              >
                Download
              </Button>

            </Flex>
          </Box>
        </HStack>
      </Box >


      {/* AG Grid Table with Custom Styling */}
      < Box
        className="ag-theme-alpine"
        h={{
          base: "200px",
          sm: "300px",
          md: "400px",
          lg: "500px"
        }
        }
        w="100%"
        bg="white"
        borderRadius={{ base: "6px", md: "8px" }}
        boxShadow="0 2px 8px rgba(0, 0, 0, 0.1)"
        mb={{ base: 3, lg: 0 }}
        overflow="hidden"
        sx={{

          '& .ag-header': {
            backgroundColor: '#C72127',
            borderBottom: 'none',
          },
          '& .ag-header-cell': {
            backgroundColor: '#C72127',
            color: 'white',
            fontWeight: 'bold',
            borderRight: '1px solid rgba(255, 255, 255, 0.2)',
          },
          '& .ag-header-cell-text': {
            color: 'white',
            fontSize: { base: '11px', sm: '12px', md: '14px' },
            fontWeight: 'bold',
          },
          '& .ag-header-icon': {
            color: 'white',
          },
          '& .ag-cell': {
            fontSize: { base: '11px', sm: '12px', md: '14px' },
            padding: '8px 12px',
            // lineHeight: '1.5',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            borderRight: '2px solid #cbd5e0',
            borderBottom: '2px solid #cbd5e0',
          },
          // Hide default pagination
          '& .ag-paging-panel': {
            display: 'none',
          },
          '& .ag-row': {
            borderBottom: '1px solid #cbd5e0',
          },
          '& .ag-root-wrapper': {
            border: '1px solid #cbd5e0',
          },
          '& .ag-filter': {
            backgroundColor: 'white',
            padding: '12px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },

          // Filter input field
          '& .ag-filter input': {
            padding: '8px 12px',
            fontSize: '14px',
            borderRadius: '6px',
            border: '1px solid #cbd5e0',
          },
          '& .ag-filter select': {
            padding: '8px 12px',
            fontSize: '14px',
            borderRadius: '6px',
            border: '1px solid #cbd5e0',
            backgroundColor: 'white',
          },

          // Filter buttons
          '& .ag-filter button': {
            padding: '6px 12px',
            fontSize: '13px',
            borderRadius: '6px',
            marginTop: '8px',
          },
          '& .ag-filter-body-wrapper': {
            padding: '8px',
          },
          '& .ag-input-wrapper .ag-icon': {
            display: 'none',
          },
          '& .ag-filter-filter .ag-wrapper': {
            '&::before': {
              display: 'none',
            },
          },

          '& .ag-filter-filter input[placeholder="Filter..."]': {
            paddingLeft: '8px',
            backgroundImage: 'none',
          },
        }}
      >
        {
          loading ? (
            <Flex justify="center" align="center" h="100%" >
              <Spinner size={{ base: "xl", md: "2xl" }} color="red.500" thickness="15px" />
            </Flex>
          ) : (
            <AgGridReact
              rowData={filterStores}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              pagination={true}
              paginationPageSize={pageSize}
              domLayout="normal"
              suppressCellFocus={true}
              onFilterChanged={onFilterChanged}
              animateRows={true}
              rowHeight={window.innerWidth < 768 ? 55 : 60}  // Changed from 45 : 50
              headerHeight={window.innerWidth < 768 ? 55 : 65}
              suppressPaginationPanel={true}
              onGridReady={onGridReady}
              onPaginationChanged={(params) => {
                setCurrentPage(params.api.paginationGetCurrentPage() + 1);
              }}
              enableCellTextSelection={true}
              ensureDomOrder={true}
        //       overlayNoRowsTemplate={
        //         < div style = "padding: 40px; text-align: center;" >
        //   <div style="font-size: 18px; font-weight: bold; color: #2D3748; margin-bottom: 8px;">No Data Available</div>
        //   <div style="font-size: 14px; color: #718096;">No stores found matching the selected criteria</div>
        // </div > 
        //       }
            />
          )}
      </Box >

      {/* Custom Pagination */}
      < Flex
        justify="space-between"
        align="center"
        mt={4}
        px={{ base: 2, md: 4 }}
        flexDirection={{ base: "column", sm: "row" }}
        gap={{ base: 3, sm: 0 }}
      >
        <Text fontSize={{ base: "xs", sm: "sm" }} color="gray.600">
          Showing {filteredCount > 0 ? ((currentPage - 1) * pageSize) + 1 : 0} to{" "}
          {Math.min(currentPage * pageSize, filteredCount)} of {filteredCount} stores
        </Text>

        <Flex gap={2} align="center">
          <Button
            onClick={handlePrevious}
            isDisabled={currentPage === 1}
            size="sm"
            fontSize={{ base: "md", md: "lg" }}
            variant="outline"
            colorScheme="gray"
            leftIcon={<ChevronLeftIcon />}
            boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
            _hover={{
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
            }}
            _disabled={{
              opacity: 0.4,
              cursor: "not-allowed",
              boxShadow: "none",
            }}
          >
            Previous
          </Button>

          <Flex
            align="center"
            justify="center"
            bg="red.500"
            color="white"
            w={{ base: "32px", md: "40px" }}
            h={{ base: "32px", md: "40px" }}
            borderRadius="md"
            fontWeight="bold"
            fontSize={{ base: "sm", md: "md" }}
            boxShadow="0 2px 4px rgba(199, 33, 39, 0.3)"
          >
            {currentPage}
          </Flex>

          <Button
            onClick={handleNext}
            isDisabled={currentPage >= totalPages}
            size="sm"
            fontSize={{ base: "md", md: "lg" }}
            variant="outline"
            colorScheme="gray"
            rightIcon={<ChevronRightIcon />}
            boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
            _hover={{
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
            }}
            _disabled={{
              opacity: 0.4,
              cursor: "not-allowed",
              boxShadow: "none",
            }}
          >
            Next
          </Button>
        </Flex>
      </Flex >

      {/* Image Modal */}
      < Modal
        isOpen={isOpen}
        onClose={onClose}
        size={{ base: "full", sm: "lg", md: "2xl", lg: "3xl" }}
        scrollBehavior="inside"
        isCentered

      >
        <ModalOverlay bg="blackAlpha.600" />
        <ModalContent
          mx={{ base: 0, sm: 4 }}
          my={{ base: 0, sm: 4 }}
          maxW={{ base: "100%", sm: "90%", md: "800px", lg: "900px" }}
          maxH={{ base: "100vh", sm: "90vh" }}
        >
          <ModalHeader
            fontSize={{ base: "md", sm: "lg", md: "xl" }}
            py={{ base: 3, md: 4 }}
            bg="red.500"
            color="white"
            borderBottom="1px solid"
            borderColor="gray.200"
          >
            {selectedStore?.storeName || "Store Image"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={{ base: 4, md: 6 }} px={{ base: 3, md: 6 }}>
            {imageLoading ? (
              <Flex
                justify="center"
                align="center"
                h={{ base: "300px", sm: "400px", md: "500px" }}
              >
                <Spinner size={{ base: "xl", md: "2xl" }} color="red.500" thickness="15px" />
              </Flex>
            ) : imageUrl ? (
              <Image
                src={imageUrl}
                alt={selectedStore?.storeName}
                w="100%"
                maxH={{ base: "60vh", sm: "55vh", md: "60vh" }}
                objectFit="contain"
                borderRadius="md"
                fallback={
                  <Flex
                    justify="center"
                    align="center"
                    h={{ base: "300px", sm: "400px", md: "500px" }}
                    bg="gray.100"
                  >
                    <Text color="black.500" fontSize={{ base: "sm", md: "md" }} fontWeight="bold">
                      Loading....
                    </Text>
                  </Flex>
                }
              />
            ) : (
              <Flex
                justify="center"
                align="center"
                h={{ base: "300px", sm: "400px", md: "500px" }}
                bg="gray.50"
              >
                <Text color="gray.500" fontSize={{ base: "sm", md: "md" }}>
                  No image available
                </Text>
              </Flex>
            )}
          </ModalBody>
        </ModalContent>
      </Modal >
    </Box >
  )
}